module.exports = __webpack_public_path__ + "static/halco-604fb03545db5cdd0c5f8036bf298dee.png";